import { updateCanvasStoryboards } from "@/store/supabaseSlice";
import { StoryboardDelta } from "@/store/zustand/changeLedgerTypes";
import { usePagesStore } from "@/store/zustand/pagesStore";
import { STORYBOARD_TYPES } from "@/utils/constants";
import { generateStoryboardFilename } from "@/utils/fileNameUtils";
import { Storyboard } from "@/utils/types";

const useUpdateStoryboardName = (canvas: any) => {
  const setName = async (storyboard: Storyboard, name: string | null) => {
    const newName = name || storyboard.name || "";

    // Get the page config path for this storyboard
    const pageConfigPath = usePagesStore
      .getState()
      .getPageSourcePath(canvas.id, storyboard.pageId || "");

    let fileRenameInfo: { oldFilePath?: string; newFilePath?: string } = {};

    // Check if we should rename the file (only for COMPONENT/STORY types with fullFilePath)
    if (
      storyboard.fullFilePath &&
      storyboard.type !== STORYBOARD_TYPES.APPLICATION
    ) {
      const currentFilename = storyboard.fullFilePath.split("/").pop() || "";
      const idPrefix = storyboard.id.split("-")[0];
      const ext = currentFilename.includes(".")
        ? "." + currentFilename.split(".").pop()
        : ".tsx";

      // Check if filename matches our pattern: {Name}-{idPrefix}.{ext}
      // The pattern is: anything followed by -{idPrefix}.{ext}
      const escapedExt = ext.replace(".", "\\.");
      const pattern = new RegExp(`^(.+)-${idPrefix}${escapedExt}$`);
      const patternMatch = currentFilename.match(pattern);

      if (patternMatch) {
        // File follows our pattern - compute new filename
        const newFilename = generateStoryboardFilename(
          newName,
          storyboard.id,
          ext,
        );
        const folderPath = storyboard.fullFilePath.replace(/\/[^/]+$/, ""); // Remove filename

        // Only include file rename info if the filename would actually change
        if (currentFilename !== newFilename) {
          fileRenameInfo = {
            oldFilePath: storyboard.fullFilePath,
            newFilePath: `${folderPath}/${newFilename}`,
          };
        }
      }
    }

    const storyboardDeltas: StoryboardDelta[] = [
      {
        changeType: "update",
        storyboardId: storyboard.id,
        pageId: storyboard.pageId || "",
        pageConfigPath,
        storyboardUpdateDict: {
          name: newName,
        },
        ...fileRenameInfo,
      },
    ];
    updateCanvasStoryboards(canvas.id, storyboardDeltas, undefined, true);
  };

  return { setName };
};

export default useUpdateStoryboardName;
